import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Panel } from 'rsuite';
import styled from 'styled-components';
import {
  getIsFetching,
  getReportTemplatesByFileType
} from '../../redux/selectors/report-template';
import { fetchReportTemplates } from '../../redux/sagas/routines';
import ReportTemplatesList from '../ReportTemplatesList';

export const PresetsPanel = styled(Panel)`
  margin-bottom: 20px;
  & > .rs-panel-heading {
    padding: 0;
  }
`;

export const PresetsPanelHeader = styled.h5`
  padding: 20px;
  color: #1675e0;
`;

const CollapsiblePresets = ({ headerLabel, type, onSelect }) => {
  const dispatch = useDispatch();
  const [expand, setExpand] = useState(false);
  const isFetching = useSelector(getIsFetching);
  const templates = useSelector(state =>
    getReportTemplatesByFileType(state, type)
  );

  const handleSelect = template => {
    onSelect(template);
    setExpand(false);
  };

  useEffect(() => {
    dispatch(fetchReportTemplates({ qs: { fileType: type } }));
  }, []);

  const handleToggle = () => {
    setExpand(!expand);
  };

  return (
    <PresetsPanel
      shaded
      collapsible
      expanded={expand}
      header={
        <PresetsPanelHeader onClick={handleToggle}>
          {headerLabel}
        </PresetsPanelHeader>
      }
    >
      <ReportTemplatesList
        data={templates}
        loading={isFetching}
        onSelect={handleSelect}
        height={400}
        autoHeight={false}
        // style={{ maxHeight: 500 }}
      />
    </PresetsPanel>
  );
};

CollapsiblePresets.propTypes = {
  type: PropTypes.string.isRequired,
  headerLabel: PropTypes.string,
  onSelect: PropTypes.func.isRequired
};

CollapsiblePresets.defaultProps = {
  headerLabel: 'Presets'
};

export default CollapsiblePresets;
